import React, { useEffect } from 'react';
import { useState } from 'react';
import cardArt from '../assets/cardArt.png';
import freeTag from '../assets/freeTag.png';
import cardStack from '../assets/cardStack.png';
import global from '../assets/global.png';
import offramp from '../assets/offramp.png';
import b2bConnection from '../assets/b2bConnection.png';
import tokens from '../assets/tokens.png';
import wallets from '../assets/wallets.png';
import axios from 'axios';
import Select from 'react-select';
import NavBar from '../components/navbar';
import { cardFAQs } from '../constants/data';

export default function CypherCard() {
  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState();
  const [email, setEmail] = useState('');
  const [signupStatus, setSignupStatus] = useState(false);
  const [expandedIndex, setExpandedIndex] = useState(null);

  useEffect(() => {
    void getCountries();
  }, []);

  const getCountries = async () => {
    const response = await axios.get(
      'https://public.cypherd.io/js/countryMaster.js'
    );
    if (response.data) {
      setCountries(response.data);
    }
  };

  const signupForcard = async () => {
    setSignupStatus('loading');
    const response = await axios.post(
      'https://arch.cypherd.io/v1/cards/waitlist',
      {
        email,
        country: selectedCountry.value,
      }
    );
    if (response.status === 201) {
      setSignupStatus(true);
    } else {
      setSignupStatus(false);
    }
  };

  const toggleFAQ = (index) => {
    if (index === expandedIndex) {
      setExpandedIndex(null);
    } else {
      setExpandedIndex(index);
    }
  };
  return (
    <div class='flex flex-col justify-center items-center w-full'>
      <div class='pt-5'>
        <NavBar />
      </div>
      <div class='flex flex-col items-center justify-center min-h-screen lg:w-[85%]'>
        <div class='container mx-auto text-center mb-8 mt-24'>
          <div class='text-4xl md:text-4xl lg:text-5xl font-bold text-gray-700 mb-4'>
            Cypher Card
          </div>
          <div className='flex justify-center'>
            <a href='#signup'>
              <div class='bg-appBg font-bold text-md py-4 px-16 rounded mt-12'>
                Signup Now
              </div>
            </a>
          </div>
          <div
            class='text-gray-700 underline mt-2 text-sm cursor-pointer'
            onClick={() =>
              window.open('https://app.cypherhq.io/#/card', '_blank')
            }
          >
            I have an invite code
          </div>
        </div>

        <div class='container mx-auto flex justify-center items-center my-12'>
          <img src={cardArt} className='w-[40%] object-contain' alt='' />
        </div>

        <div
          class='w-full lg:w-[55%] p-8 rounded-xl shadow-lg'
          style={{
            backgroundImage:
              'repeating-linear-gradient(149deg,#e9fff8,#ffe9e4 33%,#e3e7ff 73%,#fff1ca)',
          }}
        >
          <div class='grid grid-cols-2 gap-4'>
            {/* <div class='bg-transparent rounded-lg shadow-xl mb-2 flex flex-col justify-between'>
            <div class='flex justify-end h-[35%]'>
              <img src={freeTag} className='' alt='' />
            </div>
            <p className='p-4 font-bold'>
              Zero Fee, <br />
              Life Time Free
            </p>
          </div> */}

            <div class='bg-transparent rounded-lg shadow-xl mb-2 flex flex-col justify-between pl-[3%] pb-[5%]'>
              <img
                src={freeTag}
                alt=''
                className='w-[50%] object-contain self-end'
              />
              <div>
                <p className='font-semibold lg:text-[16px] text-[12px]'>
                  Zero Fee,
                  <br /> Life Time Free
                </p>
              </div>
            </div>
            <div class='bg-transparent rounded-lg shadow-xl mb-2 flex flex-col justify-between pl-[3%] pb-[5%]'>
              <img
                src={cardStack}
                alt=''
                className='w-[50%] object-contain self-end'
              />
              <div>
                <p className='font-semibold lg:text-[16px] text-[12px]'>
                  Both Virtual,
                  <br /> And Physical
                </p>
              </div>
            </div>
            <div class='bg-transparent rounded-lg shadow-xl mb-2 flex flex-col justify-between pl-[3%] pb-[5%]'>
              <img
                src={global}
                alt=''
                className='w-[50%] object-contain self-end'
              />
              <div>
                <p className='font-semibold lg:text-[16px] text-[12px]'>
                  Available
                  <br /> Globally
                </p>
              </div>
            </div>
            <div class='bg-transparent rounded-lg shadow-xl mb-2 flex flex-col justify-between pl-[3%] pb-[5%]'>
              <img
                src={offramp}
                alt=''
                className='w-[50%] object-contain self-end'
              />
              <div>
                <p className='font-semibold lg:text-[16px] text-[12px]'>
                  Instant
                  <br /> Off Ramp
                </p>
              </div>
            </div>
            <div class='bg-transparent rounded-lg shadow-xl mb-2 flex flex-col justify-between pl-[3%] pb-[5%]'>
              <img
                src={b2bConnection}
                alt=''
                className='w-[50%] object-contain self-end'
              />
              <div>
                <p className='font-semibold lg:text-[16px] text-[12px]'>
                  Supports
                  <br />
                  Businesses(KYB) with Accountant Login
                </p>
              </div>
            </div>
            <div class='bg-transparent rounded-lg shadow-xl mb-2 flex flex-col justify-between pl-[3%] pb-[5%]'>
              <img
                src={tokens}
                alt=''
                className='w-[50%] object-contain self-end'
              />
              <div>
                <p className='font-semibold lg:text-[16px] text-[12px]'>
                  Supports
                  <br /> 200+ Tokens
                </p>
              </div>
            </div>

            <div class='bg-transparent rounded-lg shadow-xl mb-2 flex flex-col justify-between pl-[3%] pb-[5%] col-span-2'>
              <img
                src={wallets}
                alt=''
                className='w-[35%] object-contain self-end'
              />
              <div>
                <p className='font-semibold lg:text-[16px] text-[12px]'>
                  Load with any Non-Custodial
                  <br /> Wallet Balances
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className='pt-12 w-full' id='signup'>
          <div
            class='container mx-auto mb-8 lg:w-[55%] flex flex-col justify-center items-center rounded-xl p-8'
            style={{
              backgroundImage:
                'linear-gradient(135deg, #ffebf7, rgba(255, 244, 206, .38))',
            }}
          >
            <h2 className='text-xl font-semibold mb-4'>
              Signup for Cypher Card
            </h2>
            {!signupStatus || signupStatus === 'loading' ? (
              <div className='flex flex-col lg:w-[40%] w-[80%] mt-6'>
                <div className='mb-4'>
                  <Select
                    value={selectedCountry}
                    class='py-3'
                    placeholder='Selct country'
                    onChange={(e) => {
                      if (e) {
                        setSelectedCountry(e);
                      }
                    }}
                    isSearchable={true}
                    options={countries.map((country) => {
                      return { value: country.Iso2, label: country.name };
                    })}
                  />
                  {/* <select
              id='country'
              name='country'
              className='appearance-none border text-sm w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline rounded-md'
            >
              {countries.map((country, index) => (
                <option key={index} value={country}>
                  {country}
                </option>
              ))}
            </select> */}
                </div>
                <div className='mb-4'>
                  <input
                    type='email'
                    id='email'
                    name='email'
                    value={email}
                    onChange={(e) => {
                      setEmail(e.target.value);
                    }}
                    className='appearance-none border rounded-md text-sm w-full py-3 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline'
                    placeholder='Enter email'
                    required
                  />
                </div>
                <button
                  type='submit'
                  onClick={() => void signupForcard()}
                  className='bg-appBg font-bold py-3 px-12 rounded focus:outline-none focus:shadow-outline self-center text-sm'
                >
                  {signupStatus === 'loading' ? 'Please wait...' : 'Signup'}
                </button>
              </div>
            ) : (
              <div className='flex flex-col lg:w-[50%] mt-6'>
                <button className='bg-appBg font-semibold py-6 px-12 rounded focus:outline-none focus:shadow-outline self-center text-sm'>
                  Thank You! Invite code has been sent to your email
                </button>
              </div>
            )}
          </div>
        </div>
        <div
          class='container mx-auto mb-8 lg:w-[55%] flex flex-col justify-center items-center mt-6 rounded-xl p-8'
          style={{
            backgroundImage:
              'linear-gradient(135deg, #f9f9ff, rgba(189, 255, 239, .2))',
          }}
        >
          <h1 className='text-3xl font-semibold text-center mb-4'>
            Frequently Asked Questions
          </h1>
          <h1 className='text-lg font-normal text-center mb-8'>
            Have questions ? We're here to help
          </h1>
          <div className='space-y-4 w-full lg:w-[80%]'>
            {cardFAQs.map((faq, index) => (
              <div
                key={index}
                className='bg-transparent border-b-[1px] border-gray-300'
              >
                <div
                  className='flex justify-between items-center p-4 cursor-pointer'
                  onClick={() => toggleFAQ(index)}
                >
                  <h2 className='text-lg font-medium'>{faq.question}</h2>
                  <span className='text-xl'>
                    {expandedIndex === index ? '-' : '+'}
                  </span>
                </div>
                {expandedIndex === index && (
                  <div className='p-4'>
                    <p className='text-gray-600'>{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
